import request from '@/utils/request'
import config from '@/config'
import request2 from '@/utils/request2'

export default {
  // 获取时段水位统计
  getIntervalWaterStatistics (params) {
    return request.get(config.ApiYJ + '/RiverWaterSituation/IntervalWaterStatistics', { params })
  },
  // 导出时段水位统计
  exportIntervalWaterStatistics (params) {
    return request2.get(config.ApiYJ + '/RiverWaterSituation/ExportIntervalWaterStatistics', { params })
  },
  // 水库时段水位统计
  getReservoirIntervalWaterStatistics (params) {
    return request.get(config.ApiYJ + '/RiverWaterSituation/ReservoirIntervalWaterStatistics', { params })
  },
  // 水库水位过程
  getReservoirWaterProcedure (params) {
    return request.get(config.ApiYJ + '/RiverWaterSituation/ReservoirWaterProcedure', { params })
  },
  // 导出水库时段水位统计
  exportReservoirIntervalWaterStatistics (params) {
    return request2.get(config.ApiYJ + '/RiverWaterSituation/ExportReservoirIntervalWaterStatistics', { params })
  },
  // 导出水库水位过程
  exportReservoirWaterProcedure (params) {
    return request2.get(config.ApiYJ + '/RiverWaterSituation/ExportReservoirWaterProcedure', { params })
  }
}
